import { render, staticRenderFns } from "./ClinicDetailPrescription.vue?vue&type=template&id=9f2154f4&scoped=true&"
import script from "./ClinicDetailPrescription.vue?vue&type=script&lang=js&"
export * from "./ClinicDetailPrescription.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDetailPrescription.vue?vue&type=style&index=0&id=9f2154f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2154f4",
  null
  
)

export default component.exports